import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a5ac0104 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _1bed2f76 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _42a89999 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _557d1965 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _74da5605 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _9297fe5e = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _035519cf = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _768c4a2c = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _efa16e1a = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _a3a229d8 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _8fa10e30 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _51f80aa8 = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _fb7faef6 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _2a0d9b3d = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _5d885ee8 = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _73db8bcf = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _234b0445 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _70284114 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _6da1a254 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _5348a9ef = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _6a0dcb0d = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _75b4ce01 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _95ddb868 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _2595acdc = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _4d42e65a = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _9d9e8666 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _63ea01eb = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _2ead0e5d = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _7073f6d8 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _4a17eef9 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _00680730 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _9e280830 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _9cd8a6ac = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _34dfccfa = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _31191e15 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _c9bc596e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _1e7c3b55 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _34ffd3fb = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7ac4f90a = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _f4017472 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _710fc3d0 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _5b275fd6 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _ca51f450 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _07008938 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _0035d1e4 = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _287b2728 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _58877430 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _f6f0f878 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _904a316a = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _4694b393 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _d0ba6b28 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _6ccae85e = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _06a7b391 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _0b7b0a14 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _5244cd26 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _3b621ad2 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _2617add3 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _1f113a84 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _5c9de6bc = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _d11ce316 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _03ae1598 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _0797d850 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _7f11a1bd = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _ace46d34 = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _6e922e41 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _41eaed3e = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _26bfd4a6 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _48d0ec1b = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _13969550 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _2e77d0c4 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _3081ed1c = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _10eb0340 = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _0f0ad3d0 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _35d89710 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _a5ac0104,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _1bed2f76,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _42a89999,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _557d1965,
    name: "calendar"
  }, {
    path: "/customer",
    component: _74da5605,
    name: "customer"
  }, {
    path: "/details",
    component: _9297fe5e,
    name: "details"
  }, {
    path: "/goals",
    component: _035519cf,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _768c4a2c,
    name: "maisoku"
  }, {
    path: "/media",
    component: _efa16e1a,
    name: "media"
  }, {
    path: "/privacy",
    component: _a3a229d8,
    name: "privacy"
  }, {
    path: "/project",
    component: _8fa10e30,
    name: "project"
  }, {
    path: "/response",
    component: _51f80aa8,
    name: "response"
  }, {
    path: "/achievement/output",
    component: _fb7faef6,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _2a0d9b3d,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _5d885ee8,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _73db8bcf,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _234b0445,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _70284114,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _6da1a254,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _5348a9ef,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _6a0dcb0d,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _75b4ce01,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _95ddb868,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _2595acdc,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _4d42e65a,
    name: "response-registration"
  }, {
    path: "/setting/announcement",
    component: _9d9e8666,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _63ea01eb,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _2ead0e5d,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _7073f6d8,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _4a17eef9,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _00680730,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _9e280830,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _9cd8a6ac,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _34dfccfa,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _31191e15,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _c9bc596e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _1e7c3b55,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _34ffd3fb,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7ac4f90a,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _f4017472,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _710fc3d0,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _5b275fd6,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _ca51f450,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _07008938,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _0035d1e4,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _287b2728,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _58877430,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _f6f0f878,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _904a316a,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _4694b393,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _d0ba6b28,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _6ccae85e,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _06a7b391,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _0b7b0a14,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _5244cd26,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _3b621ad2,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _2617add3,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _1f113a84,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _5c9de6bc,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _d11ce316,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _03ae1598,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _0797d850,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _7f11a1bd,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _ace46d34,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _6e922e41,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _41eaed3e,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _26bfd4a6,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _48d0ec1b,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _13969550,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _2e77d0c4,
    name: "property-property",
    children: [{
      path: "contact",
      component: _3081ed1c,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _10eb0340,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _0f0ad3d0,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _35d89710,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
